/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GroupManagementCreateGroupRequest } from "../models/GroupManagementCreateGroupRequest";
import type { GroupManagementCreateGroupResponseApiRespoonse } from "../models/GroupManagementCreateGroupResponseApiRespoonse";
import type { GroupManagementEditGroupInfoRequest } from "../models/GroupManagementEditGroupInfoRequest";
import type { GroupManagementEditGroupInfoResponseApiRespoonse } from "../models/GroupManagementEditGroupInfoResponseApiRespoonse";
import type { GroupManagementEditGroupRequest } from "../models/GroupManagementEditGroupRequest";
import type { GroupManagementEditGroupResponseApiRespoonse } from "../models/GroupManagementEditGroupResponseApiRespoonse";
import type { GroupManagementListGroupRequest } from "../models/GroupManagementListGroupRequest";
import type { GroupManagementListGroupResponseApiRespoonse } from "../models/GroupManagementListGroupResponseApiRespoonse";
import type { GroupManagementShowGroupInfoRequest } from "../models/GroupManagementShowGroupInfoRequest";
import type { GroupManagementShowGroupInfoResponseApiRespoonse } from "../models/GroupManagementShowGroupInfoResponseApiRespoonse";
import type { GroupManagementShowGroupRequest } from "../models/GroupManagementShowGroupRequest";
import type { GroupManagementShowGroupResponseApiRespoonse } from "../models/GroupManagementShowGroupResponseApiRespoonse";
import type { GroupManagementUserGroupRequest } from "../models/GroupManagementUserGroupRequest";
import type { GroupManagementUserGroupResponseApiRespoonse } from "../models/GroupManagementUserGroupResponseApiRespoonse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class GroupManagerService {
  /**
   * Update group info
   * @param requestBody
   * @returns GroupManagementEditGroupInfoResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static groupAdminGroupInfoEdit(
    requestBody: GroupManagementEditGroupInfoRequest
  ): CancelablePromise<GroupManagementEditGroupInfoResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/group_admin/group_info/edit",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Get group info by id
   * @param requestBody
   * @returns GroupManagementShowGroupInfoResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static groupAdminGroupInfoShow(
    requestBody: GroupManagementShowGroupInfoRequest
  ): CancelablePromise<GroupManagementShowGroupInfoResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/group_admin/group_info/show",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Get list group
   * @param requestBody
   * @returns GroupManagementListGroupResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static adminGroup(
    requestBody: GroupManagementListGroupRequest
  ): CancelablePromise<GroupManagementListGroupResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/admin/group",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Create group
   * @param requestBody
   * @returns GroupManagementCreateGroupResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static adminGroupCreate(
    requestBody: GroupManagementCreateGroupRequest
  ): CancelablePromise<GroupManagementCreateGroupResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/admin/group/create",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Get group by id
   * @param requestBody
   * @returns GroupManagementShowGroupResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static adminGroupShow(
    requestBody: GroupManagementShowGroupRequest
  ): CancelablePromise<GroupManagementShowGroupResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/admin/group/show",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Update group
   * @param requestBody
   * @returns GroupManagementEditGroupResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static adminGroupEdit(
    requestBody: GroupManagementEditGroupRequest
  ): CancelablePromise<GroupManagementEditGroupResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/admin/group/edit",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Users group
   * @param requestBody
   * @returns GroupManagementUserGroupResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static adminGroupUsers(
    requestBody: GroupManagementUserGroupRequest
  ): CancelablePromise<GroupManagementUserGroupResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/admin/group/users",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Get group info by id
   * @param requestBody
   * @returns GroupManagementShowGroupInfoResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static memberGroupInfoShow(
    requestBody: GroupManagementShowGroupInfoRequest
  ): CancelablePromise<GroupManagementShowGroupInfoResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/member/group_info/show",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }
}
